import api from './client';

export const shippingApi = {
  getShipmentPlan: (limit = 100, offset = 0, filters = {}) => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('offset', offset);
    if (filters.productQuery) {
      params.append('product_query', filters.productQuery);
    }
    if (filters.productDispExact) {
      params.append('product_disp_exact', filters.productDispExact);
    }
    if (filters.customerName) {
      params.append('customer_name', filters.customerName);
    }
    if (filters.customerNameExact) {
      params.append('customer_name_exact', 'true');
    }
    if (filters.startDate) {
      params.append('start_date', filters.startDate);
    }
    if (filters.endDate) {
      params.append('end_date', filters.endDate);
    }
    if (filters.searchBaseDate) {
      params.append('search_base_date', filters.searchBaseDate);
    } else {
      params.append('search_base_date', 'order_date');
    }
    if (filters.shipmentDateNullOnly) {
      params.append('shipment_date_null_only', 'true');
    }
    if (filters.defectiveOnly) {
      params.append('cancel_return_issue_only', 'true');
    }
    if (filters.shipmentDate) {
      params.append('shipment_date', filters.shipmentDate);
    }
    if (filters.nonyusaki) {
      params.append('nonyusaki', filters.nonyusaki);
    }
    if (filters.period) {
      params.append('period', filters.period);
    }
    if (filters.currentPeriodOnly) {
      params.append('current_period_only', 'true');
    }
    if (filters.previousPeriodsOnly) {
      params.append('previous_periods_only', 'true');
    }
    return api.get(`/api/shipping/shipment-plan?${params.toString()}`);
  },
  updateShipmentPlan: (hacchuCode, hacchuChangecnt, hacchuDatacode, data) => {
    return api.put(`/api/shipping/shipment-plan/${hacchuCode}/${hacchuChangecnt}/${hacchuDatacode}`, data);
  },
  getHacchuSplitPlans: (hacchuCode, hacchuChangecnt, hacchuDatacode) => {
    return api.get(`/api/shipping/hacchu-split-plans/${hacchuCode}/${hacchuChangecnt}/${hacchuDatacode}`);
  },
  createHacchuSplitPlan: (hacchuCode, hacchuChangecnt, hacchuDatacode, data) => {
    return api.post(`/api/shipping/hacchu-split-plans/${hacchuCode}/${hacchuChangecnt}/${hacchuDatacode}`, data);
  },
  updateHacchuSplitPlan: (hacchuCode, hacchuChangecnt, hacchuDatacode, splitNo, data) => {
    return api.put(`/api/shipping/hacchu-split-plans/${hacchuCode}/${hacchuChangecnt}/${hacchuDatacode}/${splitNo}`, data);
  },
  deleteHacchuSplitPlan: (hacchuCode, hacchuChangecnt, hacchuDatacode, splitNo) => {
    return api.delete(`/api/shipping/hacchu-split-plans/${hacchuCode}/${hacchuChangecnt}/${hacchuDatacode}/${splitNo}`);
  },
  getPurchaseOrderDetails: (hacchuNo) => {
    return api.get(`/api/shipping/purchase-order/${hacchuNo}/details`);
  },
  getPurchaseOrderSummary: (hacchuNo) => {
    return api.get(`/api/shipping/purchase-order/${hacchuNo}/summary`);
  },
  bulkUpdatePurchaseOrder: (hacchuNo, data) => {
    return api.put(`/api/shipping/purchase-order/${hacchuNo}/bulk-update`, data);
  },
  getSupplierShareList: (limit = 100, offset = 0, filters = {}) => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('offset', offset);
    if (filters.productQuery) {
      params.append('product_query', filters.productQuery);
    }
    if (filters.customerName) {
      params.append('customer_name', filters.customerName);
    }
    if (filters.startDate) {
      params.append('start_date', filters.startDate);
    }
    if (filters.endDate) {
      params.append('end_date', filters.endDate);
    }
    if (filters.shipmentDateNullOnly) {
      params.append('shipment_date_null_only', 'true');
    }
    if (filters.supplierResponseDueDateNullOnly) {
      params.append('supplier_response_due_date_null_only', 'true');
    }
    if (filters.supplierResponseDueDateSetOnly) {
      params.append('supplier_response_due_date_set_only', 'true');
    }
    if (filters.shipRequestUnissuedOnly) {
      params.append('ship_request_unissued_only', 'true');
    }
    if (filters.shipRequestIssuedOnly) {
      params.append('ship_request_issued_only', 'true');
    }
    if (filters.filterSupplierCode !== undefined && filters.filterSupplierCode !== null) {
      params.append('filter_supplier_code', filters.filterSupplierCode);
    }
    if (filters.excludeSupplierCodes && filters.excludeSupplierCodes.length > 0) {
      params.append('exclude_supplier_codes', filters.excludeSupplierCodes.join(','));
    }
    if (filters.period) {
      params.append('period', filters.period);
    }
    if (filters.currentPeriodOnly) {
      params.append('current_period_only', 'true');
    }
    if (filters.previousPeriodsOnly) {
      params.append('previous_periods_only', 'true');
    }
    if (filters.classcode0 !== undefined && filters.classcode0 !== null) {
      params.append('classcode0', filters.classcode0);
    }
    if (filters.ogakiFactoryOnly) {
      params.append('ogaki_factory_only', 'true');
    }
    if (filters.todayShipOnly) {
      params.append('today_ship_only', 'true');
    }
    return api.get(`/api/shipping/supplier-share/list?${params.toString()}`);
  },
  getSupplierSharePurchaseOrder: (hacchuNo) => {
    return api.get(
      `/api/shipping/supplier-share/purchase-order/${encodeURIComponent(hacchuNo)}`
    );
  },
  supplierLogin: (supplierCode, password) => {
    return api.post(`/api/supplier-auth/login`, {
      supplier_code: supplierCode,
      password: password,
    });
  },
  getInboundSchedule: (dateFilter) => {
    const params = new URLSearchParams();
    if (dateFilter) {
      params.append('date_filter', dateFilter);
    }
    return api.get(`/api/shipping/inbound-schedule?${params.toString()}`);
  },
  getSupplierStockHistory: (supplierCode, fromDate, toDate) => {
    const params = new URLSearchParams();
    params.append('supplier_code', supplierCode);
    if (fromDate) {
      params.append('from_date', fromDate);
    }
    if (toDate) {
      params.append('to_date', toDate);
    }
    return api.get(`/api/shipping/supplier-stock/history?${params.toString()}`);
  },
  getProductsByDisp: (disps) => {
    const params = new URLSearchParams();
    params.append('disps', Array.isArray(disps) ? disps.join(',') : disps);
    return api.get(`/api/shipping/products-by-disp?${params.toString()}`);
  },
  copySupplierStockLastToToday: (supplierCode, targetDate) => {
    return api.post('/api/shipping/supplier-stock/copy-last-to-today', {
      supplier_code: supplierCode,
      target_date: targetDate,
    });
  },
  saveSupplierStockToday: (supplierCode, items) => {
    return api.post('/api/shipping/supplier-stock/save-today', {
      supplier_code: supplierCode,
      items,
    });
  },
  previewJuchuShareOverride: (body) => {
    return api.post('/api/shipping/juchu-share-override/preview', body);
  },
  batchJuchuShareOverride: (body) => {
    return api.put('/api/shipping/juchu-share-override/batch', body);
  },
  getJuchuShareOverrideHistory: ({ juchu_code, juchu_edaban, juchu_no, limit = 100 } = {}) => {
    const params = new URLSearchParams();
    if (juchu_code != null) params.append('juchu_code', juchu_code);
    if (juchu_edaban != null) params.append('juchu_edaban', juchu_edaban);
    if (juchu_no) params.append('juchu_no', juchu_no);
    if (limit) params.append('limit', limit);
    return api.get(`/api/shipping/juchu-share-override/history?${params.toString()}`);
  },
  getShipRequestCandidates: (hacchuNo) => {
    const params = new URLSearchParams();
    params.append('hacchu_no', hacchuNo);
    return api.get(`/api/shipping/ship-requests/candidates?${params.toString()}`);
  },
  issueShipRequest: (hacchuNo, clusterKey) => {
    return api.post('/api/shipping/ship-requests', {
      hacchu_no: hacchuNo,
      cluster_key: clusterKey,
    });
  },
  getShipRequests: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.hacchuNo) params.append('hacchu_no', filters.hacchuNo);
    if (filters.latestOnly === false) params.append('latest_only', 'false');
    else if (filters.latestOnly === true) params.append('latest_only', 'true');
    if (filters.arrangeStatus) params.append('arrange_status', filters.arrangeStatus);
    if (filters.includeCancelled) params.append('include_cancelled', 'true');
    if (filters.limit != null) params.append('limit', filters.limit);
    if (filters.offset != null) params.append('offset', filters.offset);
    return api.get(`/api/shipping/ship-requests?${params.toString()}`);
  },
  getShipRequest: (requestNo) => {
    return api.get(`/api/shipping/ship-requests/${encodeURIComponent(requestNo)}`);
  },
  reissueShipRequest: (requestNo) => {
    return api.post(`/api/shipping/ship-requests/${encodeURIComponent(requestNo)}/reissue`);
  },
  cancelShipRequest: (requestNo) => {
    return api.post(`/api/shipping/ship-requests/${encodeURIComponent(requestNo)}/cancel`);
  },
  arrangeShipRequest: (requestNo, arrangeStatus) => {
    return api.patch(`/api/shipping/ship-requests/${encodeURIComponent(requestNo)}/arrange`, {
      arrange_status: arrangeStatus,
    });
  },
};
